module.exports = __webpack_public_path__ + "static/media/explainerVideo1.7c56f273.mp4";